import {
	LOGIN_USER,
	REGISTER_USER,
	LOGOUT_USER,
	UPDATE_USER_INFO,
	SEND_OTP,
	VERIFY_OTP,
	RUNNING_ORDER,
	GET_WALLET_TRANSACTIONS,
	SEND_PASSWORD_RESET_EMAIL,
	VERIFY_PASSWORD_RESET_OTP,
	CHANGE_USER_PASSWORD,
	ENQUIRY_USER,
	PRODUCT_REQUEST,
} from "./actionTypes";
import {
	LOGIN_USER_URL,
	REGISTER_USER_URL,
	UPDATE_USER_INFO_URL,
	SEND_OTP_URL,
	VERIFY_OTP_URL,
	CHECK_USER_RUNNING_ORDER_URL,
	GET_WALLET_TRANSACTIONS_URL,
	SEND_PASSWORD_RESET_EMAIL_URL,
	VERIFY_PASSWORD_RESET_OTP_URL,
	CHANGE_USER_PASSWORD_URL,
	ENQUIRY_URL,
	PRODUCT_URL, keyValue,
} from "../../configs";

import Axios from "axios";

export const loginUser = ( email, password) => (dispatch) => {
	Axios.defaults.headers.common = {
          "X-API-Key": keyValue,
        };
	Axios.post(LOGIN_USER_URL, {	
		email_id: email,
		password: password,		
	})
		.then((response) => {
			const user = response.data;
			return dispatch({ type: LOGIN_USER, payload: user });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const registerUser = (name, email, phone, password) => (dispatch) => {
	Axios.defaults.headers.common = {
          "X-API-Key": keyValue,
        };
	Axios.post(REGISTER_USER_URL, {
		firstname: name,
		email_id: email,
		phone: phone,
		password: password,
	})
		.then((response) => {
			const user = response.data;
			return dispatch({ type: REGISTER_USER, payload: user });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const logoutUser = (user) => (dispatch) => {
	user = [];
	const walletEmpty = [];

	//remove geoLocation and userSetAddress
	localStorage.removeItem("userSetAddress");
	localStorage.removeItem("geoLocation");
	localStorage.removeItem("lastSavedNotificationToken");

	dispatch({
		type: LOGOUT_USER,
		payload: user,
	});
	dispatch({
		type: RUNNING_ORDER,
		payload: false,
	});
	dispatch({
		type: GET_WALLET_TRANSACTIONS,
		payload: walletEmpty,
	});
};

export const updateUserInfo = (user_id) => (dispatch) => {
	Axios.defaults.headers.common = {
          "X-API-Key": keyValue,
        };
	return Axios.post(UPDATE_USER_INFO_URL, {
		customer_id: user_id,
	})
		.then((response) => {
			const user = response.data;
			return dispatch({ type: UPDATE_USER_INFO, payload: user });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const checkUserRunningOrder = (user_id, token) => (dispatch) => {
	Axios.post(CHECK_USER_RUNNING_ORDER_URL, {
		token: token,
		user_id: user_id,
	})
		.then((response) => {
			const running_order = response.data;
			return dispatch({ type: RUNNING_ORDER, payload: running_order });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const sendOtp = (email, phone, accessToken, provider) => (dispatch) => {
	return Axios.post(SEND_OTP_URL, {
		email: email,
		phone: phone,
		accessToken: accessToken,
		provider: provider,
	})
		.then((response) => {
			const user = response.data;
			return dispatch({ type: SEND_OTP, payload: user });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const verifyOtp = (phone, otp) => (dispatch) => {
	Axios.post(VERIFY_OTP_URL, {
		phone: phone,
		otp: otp,
	})
		.then((response) => {
			const user = response.data;
			return dispatch({ type: VERIFY_OTP, payload: user });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const getWalletTransactions = (token, user_id) => (dispatch) => {
	Axios.post(GET_WALLET_TRANSACTIONS_URL, {
		token: token,
		user_id: user_id,
	})
		.then((response) => {
			const wallet = response.data;
			return dispatch({ type: GET_WALLET_TRANSACTIONS, payload: wallet });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const sendPasswordResetMail = (email) => (dispatch) => {
	Axios.defaults.headers.common = {
          "X-API-Key": keyValue,
        };
	Axios.post(SEND_PASSWORD_RESET_EMAIL_URL, {
		email_id: email,
	})
		.then((response) => {
			const data = response.data;
			return dispatch({ type: SEND_PASSWORD_RESET_EMAIL, payload: data });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const verifyPasswordResetOtp = (email, code) => (dispatch) => {
	Axios.post(VERIFY_PASSWORD_RESET_OTP_URL, {
		email: email,
		code: code,
	})
		.then((response) => {
			const data = response.data;
			return dispatch({ type: VERIFY_PASSWORD_RESET_OTP, payload: data });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const changeUserPassword = (email, code, password) => (dispatch) => {
	Axios.post(CHANGE_USER_PASSWORD_URL, {
		email: email,
		code: code,
		password: password,
	})
		.then((response) => {
			const data = response.data;
			return dispatch({ type: CHANGE_USER_PASSWORD, payload: data });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const enquiryUser = (name, email, phone, msg, course_id) => (dispatch) => {
	Axios.defaults.headers.common = {
          "X-API-Key": keyValue,
        };
	Axios.post(ENQUIRY_URL, {
		name: name,
		email: email,
		phone: phone,
		msg: msg,
		course_id: course_id,
	})
		.then((response) => {
			const enquiry_user = response.data;
			return dispatch({ type: ENQUIRY_USER, payload: enquiry_user });
		})
		.catch(function(error) {
			console.log(error);
		});
};

export const productRequestUser = (productname,productquantity,packagesize,productbrand,origincountry,name, email, phone, msg) => (dispatch) => {
	Axios.post(PRODUCT_URL, {
		productname: productname,
		productquantity: productquantity,
		packagesize: packagesize,
		productbrand: productbrand,
		origincountry: origincountry,
		name: name,
		email: email,
		phone: phone,
		msg: msg,
	})
		.then((response) => {
			const product_request = response.data;
			return dispatch({ type: PRODUCT_REQUEST, payload: product_request });
		})
		.catch(function(error) {
			console.log(error);
		});
};
